import './DatasetModal.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import ListGroup from 'react-bootstrap/ListGroup';
import DataBrowseTable from './DataBrowseTable.js';
import { useRef } from 'react';


function DatasetModal(props) {
    const typeIcons = {
        'Numeric': <i className='las la-hashtag' />,
        'Text': <i className='las la-quote-right' />,
        'Date/Time': <i className='las la-calendar' />
    }
    const {
        datasetName, datawrapperLink, description,
        domain, lastUpdated, filename, fields, sources
    } = props.metadata;
    const dateTokens = lastUpdated.split(/\s+/);
    const updateDate = (
        `${dateTokens[0]}, ${dateTokens[1]} ${dateTokens[2]} ${dateTokens[4]}` +
        ` @ ${dateTokens[3]} ${dateTokens[5]}`
    );
    const iframeRef = useRef(null);
    return (
        <Modal show={props.show} onHide={props.handleClose} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ color: '#05436E', fontSize: '1.3rem' }}>{datasetName}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingTop: '2px'}}>
                <Tabs>
                    <Tab eventKey="overview" title="Overview">
                        <div style={{ width: "75%", margin: '0 auto' }}>
                            <iframe
                                ref={iframeRef}
                                title={datasetName + '_modal'} src={datawrapperLink} seamless
                                frameborder="0" data-external="1"
                                style={{ 
                                    width: '75%',  height: '450px', marginTop: '1em', 
                                    marginBottom: '1em', marginLeft: '12%' 
                                }}
                            ></iframe>
                            <p className="metadata-view-p" style={{ fontSize: "17px", fontWeight: 'bold' }}>
                                Download Full Dataset:
                                <a className='data-file-link' href={`https://d1c48g3icd9ay6.cloudfront.net/${domain}/${filename}`}>
                                    <span style={{ fontSize: "1.5em" }}>
                                        &nbsp;<i className='bi bi-filetype-csv'></i>
                                        &nbsp;<i className='bi bi-download'></i>
                                    </span>
                                </a>
                            </p>
                            <p className="metadata-view-p" style={{ fontSize: "16px", color: "#777" }}>Description: {description}</p>
                            <p className="metadata-view-p" style={{ fontStyle: 'italic', fontSize: "16px", color: "#777" }}>Last Updated: {updateDate}</p>
                        </div>
                    </Tab>
                    <Tab eventKey="metadata" title="Metadata">
                        <div style={{ margin: '0 auto', width: '85%' }}>
                            <p style={{ fontSize: '20px', color: '#05436E', marginTop: '1em', marginBottom: '0.5em' }}>Columns</p>
                            <Table striped hover className='metadata-table' style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th width="20%">Column Name</th>
                                        <th width="20%">Column Type</th>
                                        <th>Column Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fields.map((field, idx) => (
                                        <tr key={idx}>
                                            <td>{field.name}</td>
                                            <td>{field.type}&nbsp;&nbsp;{typeIcons[field.type]}</td>
                                            <td>{field.description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <p style={{ fontSize: '20px', color: '#05436E', marginTop: '1.2em', marginBottom: '0.5em' }}>Sources</p>
                            <ListGroup className='source-list-group'>
                                {sources.map((source, idx) => (
                                    <ListGroup.Item as="li" style={{ textAlign: 'left', padding: '0px' }} key={idx}>
                                        <a className='source-link' href={source.url} target="_blank" rel="noreferrer">
                                            <p style={{ display: 'inline', fontWeight: 'bold', fontSize: '16px' }}>{idx + 1}. {source.name}</p>
                                            <i className='las la-external-link-alt' style={{ fontSize: '24px' }}></i>
                                        </a>
                                        <p style={{ fontSize: "15px", color: "#777", marginBottom: '5px' }}>{source.note}</p>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </div>
                    </Tab>
                    <Tab eventKey="browse-data" title="Browse Data">
                        <DataBrowseTable domain={domain} filename={filename}></DataBrowseTable>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


export default DatasetModal;